export const LANDING_PAGE_LINK = "https://www.onbento.com/";
export const BRAND_LANDING_PAGE_LINK = "https://www.onbento.com/brands";
export const BENTO_RESOURCES_GUIDE_LINK =
  "https://hatchways.notion.site/Bento-Resource-Guide-b43c00e8980347fca5de92cd71c51818";
export const UNSPECIFIED = "unspecifed";
export const TERMS_AND_CONDITIONS_LINK_MONTHLY =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Virtual%20Assistant%20Monthly%20Program%20Agreement%20-%20Oct_17_updated.pdf";
export const TERMS_AND_CONDITIONS_LINK_YEARLY =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Virtual%20Assistant%20Program%20Agreement%20-%20July%2025%20Update.pdf";
export const BENTO_VA_ONBOARDING_CALENDLY_LINK =
  "https://calendly.com/jaclyn-bento/virtual-assistant-onboarding";
export const CLOSE_VA_ANNOUNCEMENT = "close_va_announcement";
export const VA_LANDING_PAGE_LINK = "https://www.onbento.com/va";
export const PARTNERSHIP_DATA_EXAMPLE =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/partnership_data.png";
export const COMMISSION_PERCENTAGE = 10;
export const AFFILIATE_TERMS_AND_CONDITIONS_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento's%20Affiliate%20Terms%20%26%20Conditions%20-%20September%202025.pdf";
export const AFFILIATE_CONTENT_FORM =
  "https://docs.google.com/forms/d/e/1FAIpQLScA75j4KjVTL-SDorbW5vPA5bkxVPEK15R2DIEvOyKJVpwmsg/viewform";

export const FAIR_PAY_TERMS_AND_CONDITIONS =
  "https://storage.googleapis.com/app-onbento-com/Creator%20Fair%20Pay%20Audit%20%E2%80%94%20Privacy%20Policy%20%26%20Terms.pdf";
export const VA_MONEY_BACK_GUARANTEE =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Updated%20Mar%2018%2C%202026%20-%20Risk-Free%20Virtual%20Assistant%20Program.pdf";
export const LIVE_COUPON_CODE = "live";

export const PRO_TERMS_AND_CONDITIONS_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Pro%20Tier%20Agreement%20-%20Feb%205%20(updated).pdf";
export const PRO_IMAGE_PREVIEW_LINK_SQUARE =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/how%20to%20mae%20your%20pro%20subscription%20preview%20square.png";
export const PRO_IMAGE_PREVIEW_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/how%20to%20make%20your%20pro%20subscription%20preview.png";
export const VA_IMAGE_PREVIEW_LINK =
  "https://storage.cloud.google.com/hatchways-crm.appspot.com/app-assets/make_the_most_of_va_preview.png";
export const FREE_BENTO_VIDEO_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Walkthrough%20of%20Bento%20Platform%20for%20Content%20Creators.mp4";
export const FREE_IMAGE_PREVIEW_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/how%20to%20use%20bento%20preview.png";

export const PRO_SUBSCRIPTION_VIDEO_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/How%20to%20make%20the%20most%20of%20your%20Pro%20Subscription.mov";
export const WELCOME_LINK =
  "https://www.loom.com/embed/4ae5d29e373a42269dfc846e99e5939d?sid=f5530923-de06-4bf2-bd00-d28f916ac589&hideEmbedTopBar=true";
export const VA_SUBSCRIPTION_VIDEO_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/make_the_most_of_va_tier.mp4";
export const HOW_TO_USE_CAMPAIGN_VIDEO_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Campaigns%20Feature%20Tutorial.mp4";
export const IG_TAGGING_TUTORIAL_VIDEO_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/IG%20Tagging%20Tutorial.mp4";
export const HOW_TO_CHANGE_NICHE_VIDEO_LINK =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/How%20to%20add%20or%20change%20a%20niche.mp4";

export const IG_TAGGING_PREVIEW =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/IG_TAGGING_PREVIEW.png";
export const CAMPAIGNS_PREVIEW =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/CAMPAIGN_PREVIEW.png";
export const CHANGE_NICHE_PREVIEW =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Screenshot%202026-01-29%20at%202.26.57%E2%80%AFPM.png";

export const EXCLUSIVE_CONTACTED_THRESHOLD = 25;
export const MAX_NUMBER_OF_FOLLOWUPS = 3;

export const BRAND_AMBASSADOR_TERMS_AND_CONDITIONS =
  "https://storage.googleapis.com/hatchways-crm.appspot.com/app-assets/Bento%E2%80%99s%20Brand%20Ambassador%20Program%20Terms%20and%20Conditions.pdf";
